<template>
  <q-card flat bordered>
    <q-card-section class="q-pa-sm bg-primary text-white">
      <div class="text-subtitle1 text-bold">
        <q-icon
          name="emoji_transportation"
          style="font-size: 25px; padding-right: 0.1rem"
        />
        Transport Information
      </div>
    </q-card-section>

    <q-separator />
    <q-card-section>
      <app-select-input
        :loadingData="loadingData"
        :readonly="readonly"
        text="Carrier *"
        textClasses="text-weight-bold"
        v-model="value.carrierType"
        :options="['OPEN', 'ENCLOSED']"
        @input="handleChange({ name: 'carrierType', model: $event })"
      />
      <app-editable-input
        v-if="context !== 'quick-quote'"
        :loadingData="loadingData"
        :data="$options.filters.usDateFormat(value.availableDate)"
        :readonly="readonly || action === 'view'"
        type="date"
        dateDisplayFormat="US"
        name="availableDate"
        text="Available Date *"
        textClasses="text-weight-bold"
        @input="
          handleChange($event);
          delayTouch(validation.availableDate, $options.touchMap);
        "
        :error="validation.availableDate.$error"
      />
      <div class="miles-box">
        <app-editable-input
          v-if="context !== 'quick-quote'"
          :loadingData="loadingData"
          readonly
          :data="miles"
          type="text"
          textClasses="text-weight-bold text-brand3"
          inputClasses="text-brand3 text-weight-bold text-large"
          name="miles"
          text="Distance(miles)"
          :bottom-slots="milesWarningText !== ''"
        />
        <span class="text-warning warning-text" v-if="milesWarningText">{{milesWarningText}}</span>
      </div>
    </q-card-section>
  </q-card>
</template>
<script>
import AppEditableInput from '@client/components/form/editable-input';
import AppSelectInput from '@client/components/form/select-input';

export default {
  name: 'AppTransportInfoCard',
  components: {
    AppEditableInput,
    AppSelectInput
  },
  props: {
    loadingData: {
      type: Boolean,
      default: false
    },
    value: Object,
    context: {
      type: String,
      default: 'quote'
    },
    readonly: Boolean,
    action: {
      type: String,
      default: 'create'
    },
    validation: Object,
    saving: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data() {
    return {
      miles: '',
      milesWarningText: ''
    };
  },
  methods: {
    handleChange(value) {
      console.log(this.unformatDate(value.model));
      const mValue = value.name === 'availableDate' ? this.unformatDate(value.model) : value.model;
      this.$emit('input', {
        ...this.value,
        [value.name]: mValue
      });

      if (this.action === 'view') {
        this.$emit('update', value.name);
      }
    },
    unformatDate(v) {
      if (v) {
        const a = v.split('/');
        return `${a?.[2]}-${a?.[0]}-${a?.[1]}`;
      }
      return '';
    },
    async calcDistance(from, to) {
      const res = await fetch(
        `/rest-api/distance?origin=${from}&destination=${to}`
      );
      this.milesWarningText = '';
      if (from === '' || to === '') {
        this.miles = 0;
        this.milesWarningText = 'No Zipcode Information';
      } else {
        try {
          this.miles = await res.json();
        } catch (e) {
          this.milesWarningText = 'Unable to fetch distance';
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.miles-box{
  position: relative;
  .warning-text{
    position: absolute;
    bottom:0;
    left:0;
  }
}
</style>
